import posthog from 'posthog-js'

// --- Funnel versioning -------------------------------------------------------
// `funnel_version` is stamped on EVERY event (including the automatic landing-page
// $pageview), so any funnel can start at the landing page and be broken down by it.
//
// It is built from two pieces:
//   * FUNNEL_BASE -- bump this whenever you ship a STRUCTURAL funnel change
//     (added/removed/reordered steps, redesigned page, new interstitial, new pricing...).
//   * a sticky funnel arm chosen once on the visitor's FIRST page load (the coin-flip
//     that used to live in eeo.js). Each arm reads as its own funnel_version, e.g.
//     "2026-06-control" / "2026-06-facts" / "2026-06-facts_early", so you compare them
//     like any other version.
//
// The variant is persisted per-browser (localStorage) so a visitor stays in one funnel
// for their whole journey and across sessions. eeo.js imports `onboardingVariant` to
// decide which onboarding page to show.
const FUNNEL_BASE = '2026-06';
const VARIANT_KEY = 'fapply_onboarding_variant';

// Three-way split (~1/3 each):
//   * control     -- no progress-facts interstitial.
//   * facts       -- progress_facts.html shown late (at eeo, before the job_assistant carousel).
//   * facts_early -- progress_facts.html shown immediately after "Get Started" on index.html,
//                    before registration.
const VARIANTS = ['control', 'facts', 'facts_early'];

function resolveOnboardingVariant() {
    let variant = null;
    try {
        variant = localStorage.getItem(VARIANT_KEY);
    } catch (e) { /* localStorage blocked (private mode) */ }

    if (!VARIANTS.includes(variant)) {
        const r = Math.random();
        // variant = r < 1 / 3 ? 'control' : r < 2 / 3 ? 'facts' : 'facts_early';
        variant = r < 1 / 2 ? 'facts' : 'facts_early';
        try {
            localStorage.setItem(VARIANT_KEY, variant);
        } catch (e) { /* keep in-memory only for this page load */ }
        return { variant, isNew: true };
    }
    return { variant, isNew: false };
}

const { variant: onboardingVariant, isNew: variantIsNew } = resolveOnboardingVariant();
export const FUNNEL_VERSION = `${FUNNEL_BASE}-${onboardingVariant}`;
export { onboardingVariant };

posthog.init('phc_zIGV5Gq0B1q7gD9rUJvt1xi90Y4XmXxzhC5GnTVb352', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    loaded: (ph) => {
        // Registered inside `loaded` so both land on the automatic initial $pageview.
        ph.register({
            funnel_version: FUNNEL_VERSION,
            onboarding_variant: onboardingVariant, // kept as its own property for back-compat
        });
        if (variantIsNew) {
            ph.capture('onboarding_variant_assigned', {
                variant: onboardingVariant,
                funnel_version: FUNNEL_VERSION,
                source: 'index_split',
            });
        }
    },
})

export default posthog
